import type { LinkButtonProps } from '@frontend/web-react';
import { LinkButton, Text } from '@frontend/web-react';
import type { ClassName } from '@frontend/web-utils';
import { applyClass, concatClasses } from '@frontend/web-utils';

type TabPillProps = LinkButtonProps & {
  isActive?: boolean;
  label: string;
  textClassName?: ClassName;
  useCustomBackground?: boolean;
};

export const TabPill = ({
  className,
  isActive,
  label,
  textClassName,
  useCustomBackground = false,
  ...props
}: TabPillProps) => (
  <LinkButton
    accessibilityLabel={label}
    className={concatClasses(
      'items-center px-md py-xs rounded-xl border-borderPrimary border-1',
      !useCustomBackground && applyClass(isActive, 'bg-neutral-950 border-neutral-950', 'bg-transparent'),
      className,
    )}
    {...props}
  >
    <Text
      className={concatClasses(
        'whitespace-nowrap',
        applyClass(isActive, 'text-trueWhite', 'text-textPrimary'),
        textClassName,
      )}
      type="caption"
    >
      {label}
    </Text>
  </LinkButton>
);
